module.exports = __webpack_public_path__ + "static/media/hm5.31469c11.PNG";